/**
 * KpiTile — a single card on the summary strip or any tab.
 *
 * Visual hierarchy: small uppercase label, large primary number, optional
 * secondary line and color tone. Hover lifts the card subtly.
 */
const TONE_CLS = {
  default: "border-slate-200",
  amber: "border-amber-300 bg-amber-50/60",
  red: "border-red-300 bg-red-50/60",
  emerald: "border-emerald-300 bg-emerald-50/60",
};

export default function KpiTile({
  label,
  value,
  Icon,
  tone = "default",
  hint,
  loading = false,
  testId,
}) {
  return (
    <div
      data-testid={testId}
      className={`group rounded-md border ${TONE_CLS[tone] || TONE_CLS.default} bg-white p-4 shadow-card transition hover:shadow-md`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="font-data text-[10px] uppercase tracking-[0.18em] text-slate-500">
          {label}
        </div>
        {Icon && (
          <Icon
            size={16}
            weight="duotone"
            className={`shrink-0 ${
              tone === "red"
                ? "text-red-600"
                : tone === "amber"
                  ? "text-amber-600"
                  : tone === "emerald"
                    ? "text-emerald-600"
                    : "text-slate-400"
            }`}
          />
        )}
      </div>
      <div
        className={`mt-2 font-heading text-2xl font-bold tabular-nums ${
          tone === "red"
            ? "text-red-700"
            : tone === "amber"
              ? "text-amber-800"
              : tone === "emerald"
                ? "text-emerald-700"
                : "text-slate-900"
        }`}
      >
        {loading ? (
          <span className="inline-block h-6 w-20 animate-pulse rounded bg-slate-200" />
        ) : (
          value
        )}
      </div>
      {hint && !loading && (
        <div className="mt-1 text-[11px] text-slate-500 leading-tight">
          {hint}
        </div>
      )}
    </div>
  );
}
